export default __webpack_public_path__ + "static/media/construccion.2f876905.png";